import useWindowWidth from './useWindowWidth';

// Hook for a right-aligned row of action buttons that has to survive narrow screens.
// The rows need roughly 430px to fit on one line, so on phones they stack full width, 
// otherwise stretched buttons stop short and look ragged.
// Wider screens keep the single row and only wrap if they genuinely run out of space.
export const useActionButtonsFlex = () => {
  const isMobile = useWindowWidth() <= 480;

  // The buttons carry inline marginRight for their spacing in a row, which would leave the stacked ones
  // a couple of pixels short of the full width -- important is the only way to beat an inline style.
  return isMobile
    ? { column: true, hAlign: 'stretch' as const, styles: { '& > button': { maxWidth: '100%', marginRight: '0 !important' } } }
    : { hAlign: 'end' as const, wrap: true, styles: { rowGap: '0.5rem' } };
};

export default useActionButtonsFlex;
